/**
 * Every string the sign-in screen renders.
 *
 * The lede carries two facts and no third: what the identity is, and that the
 * console needs a role on top of it. The second sentence is not decoration —
 * a role is granted by an operator from a user's detail and there is no route
 * by which it can be asked for, so someone holding a Shahedni account can
 * authenticate correctly here and still not reach the console. Saying so costs
 * one sentence; not saying it produces a screen that looks broken to the person
 * it is refusing.
 *
 * What is deliberately absent: any sign-in-wall notice, and any «return to the
 * surface you asked for» line. The gated surface set is the `auth_gate`
 * setting's value — title detail, the player, and subscription — and every one
 * of those lives on the subscriber host. Borrowing another surface's setting
 * onto this one would be the same defect as inventing a value for it.
 */
export const copy = {
  documentTitle: 'سجّل الدخول — وحدة تحكّم شاهدني',

  head: {
    title: 'سجّل الدخول',
    lede: 'رقم موبايلك هو هويّتك في شاهدني — شاشة الهويّة نفسها التي يفتحها المشترك، على مضيف مستقلّ وبجلسة مستقلّة. ووحدة التحكّم تحتاج دور مشغّل، يمنحه مشغّل آخر من صفحة المستخدم ولا يُطلب من هنا.',
  },

  phone: {
    label: 'رقم الموبايل',
    hintPrefix: 'مثال: ',
    hintExample: '٧٧١\u00a0٢٣٤\u00a0٥٦٧',
    hintSuffix: ' — يصلك الرمز على هذا الرقم.',
  },

  password: {
    /** No required marker: an account without a password is a valid account. */
    label: 'كلمة المرور',
    hint: 'اتركه فارغاً إن لم تضبط كلمة مرور لحسابك؛ عندها يكون الرمز طريقتك.',
  },

  actions: {
    requestCode: 'أرسل رمز الدخول',
    signInWithPassword: 'سجّل الدخول بكلمة المرور',
    offline: 'لا اتّصال — أعد المحاولة بعد عودة الشبكة',
  },

  foot: {
    forgot: 'نسيت كلمة المرور؟',
  },
} as const;
